import { z } from 'zod';
import { STTResultSchema } from './stt-result';

export const SummarizeMeetingJobSchema = z.object({
  stt: STTResultSchema.optional(),
  userContext: z.string().optional(),
});

export type SummarizeMeetingJob = z.infer<typeof SummarizeMeetingJobSchema>;
